export default ({ left, right }, context) => {
	const selectedVal = left.value ? left : right;
	return {
		type: selectedVal.type,
		value: selectedVal.value,
	};
};